import { useTranslation } from 'react-i18next'

const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm, title, description }) => {
    const { t } = useTranslation()

    if (!isOpen) return null

    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50'>
            <div className='w-full max-w-md p-6 bg-white rounded shadow'>
                <h2 className='text-lg font-semibold'>{title || t('confirmation.title')}</h2>
                <p className='mt-2 text-sm text-gray-600'>
                    {description || t('confirmation.description')}
                </p>

                <div className='flex justify-end gap-2 mt-6'>
                    <button
                        onClick={onClose}
                        className='px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300'
                    >
                        {t('confirmation.cancel')}
                    </button>
                    <button
                        onClick={onConfirm}
                        className='px-4 py-2 text-white bg-red-600 rounded hover:bg-red-700'
                    >
                        {t('confirmation.confirm')}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmDeleteModal
